import { createReducer } from "@reduxjs/toolkit";
import { deleteItemFromArray } from "@helpers/common";

import {
  getScheduledPosts,
  getScheduledPostsSuccess,
  getScheduledPostsFailure,
  getPortionScheduled,
  getPortionScheduledSuccess,
  getPortionScheduledFailure,
  scheduledPostUploaded,
  updateScheduledPost,
  deleteScheduledPost,
  deleteScheduledPostSuccess,
  deleteScheduledPostFailure,
  setScheduledPosts,
  editScheduledPost,
  editScheduledPostSuccess,
  editScheduledPostFailure,
  editScheduledPostReset,
  addPendingEditingScheduledPost,
  removePendingEditingScheduledPost,
} from "./actions";

// todo: handle all user posts for feed

/**
 * @property {number[]} allPosts array of post ids
 * @property {object[]} postsById { [postId]: {postContent} }
 */
const initialState = {
  allPosts: [],
  postById: {},
  pendingEditingPosts: [],
  totalCount: undefined,
  nextOffset: undefined,
  isLoading: true,
  error: null,
  deletePostError: null,
  isDeleting: false,
  isEditing: false,
  isEdited: false,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(getScheduledPosts.type, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(getScheduledPostsSuccess.type, (state, action) => ({
      ...state,
      ...action.payload,
      error: initialState.error,
      isLoading: false,
    }))
    .addCase(getScheduledPostsFailure.type, (state, action) => ({
      ...state,
      error: action.payload,
      isLoading: false,
    }))
    .addCase(getPortionScheduled.type, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(getPortionScheduledSuccess.type, (state, { payload }) => {
      const { allPosts, postById } = state;
      const {
        allPosts: newPosts,
        postById: newPostsById,
        totalCount,
        nextOffset,
      } = payload;

      return {
        ...state,
        allPosts: [...allPosts, ...newPosts],
        postById: { ...postById, ...newPostsById },
        totalCount,
        nextOffset,
        error: initialState.error,
        isLoading: false,
      };
    })
    .addCase(getPortionScheduledFailure.type, (state, action) => ({
      ...state,
      error: action.payload,
      isLoading: false,
    }))
    .addCase(addPendingEditingScheduledPost.type, (state, { payload }) => ({
      ...state,
      pendingEditingPosts: [...state.pendingEditingPosts, payload.postId],
    }))
    .addCase(scheduledPostUploaded.type, (state, { payload }) => {
      const { allPosts } = state;

      return {
        ...state,
        postById: { ...state.postById, [payload.id]: payload },
        allPosts,
      };
    })
    .addCase(updateScheduledPost.type, (state, { payload }) => ({
      ...state,
      postById: {
        ...state.postById,
        [payload.id]: { ...state.postById?.[payload.id], ...payload.post },
      },
    }))
    .addCase(deleteScheduledPost.type, (state) => ({
      ...state,
      isDeleting: true,
    }))
    .addCase(deleteScheduledPostSuccess.type, (state, { payload }) => ({
      ...state,
      isDeleting: false,
      deletePostError: initialState.deletePostError,
      allPosts: deleteItemFromArray(state.allPosts, payload.id),
      totalCount: state.totalCount - 1,
    }))
    .addCase(deleteScheduledPostFailure.type, (state, { payload }) => ({
      ...state,
      isDeleting: false,
      deletePostError: payload,
    }))
    .addCase(removePendingEditingScheduledPost.type, (state, { payload }) => ({
      ...state,
      pendingEditingPosts: [
        ...state.pendingEditingPosts.filter((id) => id !== payload),
      ],
    }))
    .addCase(setScheduledPosts.type, (state, { payload }) => {
      const { postById } = state;
      const { postById: newPostById } = payload;

      return {
        ...state,
        postById: { ...postById, ...newPostById },
        error: initialState.error,
        isLoading: false,
      };
    })
    .addCase(editScheduledPost, (state) => {
      state.isEditing = true;
    })
    .addCase(editScheduledPostSuccess, (state, { payload }) => {
      const { result, post } = payload;

      state.isEditing = false;
      state.isEdited = true;
      if (state.postById) {
        state.postById[result] = post;
      }
    })
    .addCase(editScheduledPostFailure, (state) => {
      state.isEditing = false;
      state.isEdited = false;
    })
    .addCase(editScheduledPostReset, (state) => {
      state.isEditing = initialState.isEditing;
      state.isEdited = initialState.isEdited;
    });
});
